import { connect } from 'react-redux'
import { doShowModal } from 'actions/modals'
import { CANNED_REPLIES } from 'constants/modal_types'
import Dropup from './view'

const perform = dispatch => ({
  doShowCannedReplyModal: modalProps =>
    dispatch(doShowModal(CANNED_REPLIES, modalProps)),
})

export default connect(null, perform)(Dropup)
